//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Dialog } from 'vant'

export default {
  props: {
    text: {
      type: String,
      default: '',
    },

    // 行数
    maxLines: {
      type: Number,
      default: 3,
    },

    width: {
      type: Number,
      default: document.body.clientWidth,
    },

    len: {
      type: Number,
      default: 0,
    },
  },

  data () {
    return {
      offset: this.len || this.text.length,
      expanded: false, // 默认展开
      slotBoxWidth: 0,
      textBoxWidth: this.width,
      showSlotNode: false,
    }
  },

  computed: {
    realText () {
      // 是否被截取
      const isCutOut = this.offset !== this.text.length
      let realText = this.text

      if (isCutOut && !this.expanded) {
        realText = `${this.text.slice(0, this.offset)}...........`
      }

      return realText
    },
  },

  mounted () {
    const { len } = this.getLines()

    // 如果总行数 > 🔝展示行数，择展示插槽内的按钮，并获取按钮的宽度
    if (len > this.maxLines) {
      this.showSlotNode = true

      this.$nextTick(() => {
        this.slotBoxWidth = this.$refs.slotRef.clientWidth
        this.textBoxWidth = this.$refs.textOverflow.clientWidth

        this.calculateOffset(0, this.text.length)
      })
    }
  },

  methods: {
    calculateOffset (from, to) {
      this.$nextTick(() => {
        if (Math.abs(from - to) <= 1) {
          return
        }

        // 是否超出指定行数
        if (this.isOverflow()) {
          to = this.offset
        } else {
          from = this.offset
        }

        this.offset = Math.floor((from + to) / 2)

        this.calculateOffset(from, to)
      })
    },

    // 是否查出指定行
    isOverflow () {
      const { len, lastWidth } = this.getLines()

      // 如果总行数 < 指定行数
      if (len < this.maxLines) {
        return false
      }

      if (this.maxLines) {
        const lastLineOver = !!(
          len === this.maxLines &&
          lastWidth + this.slotBoxWidth > this.textBoxWidth
        )

        // 超出部分 总行数 > 指定行数 或 已经是指定行数但最后一行宽度 + 插槽宽度超出正常宽度
        if (len > this.maxLines || lastLineOver) {
          return true
        }
      }

      return false
    },

    // 获取字符串文本，总行数（len），lastWidth：最后一行的宽度
    getLines () {
      const clientRects = this.$refs.overEllipsis.getClientRects()

      return {
        len: clientRects.length,
        lastWidth: clientRects[clientRects.length - 1].width,
      }
    },

    // 详情预览
    searchMore () {
      Dialog.alert({
        message: this.text,
        messageAlign: 'left',
        confirmButtonColor: '#3399fe',
        className: 'text-gray-600',
      })
    },
  },
}
